import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ChevronLeftIcon extends Component {
  render() {
    return (
      <div className={this.props.className}>
        <svg
          width="7px"
          height="12px"
          viewBox="0 0 7 12"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <polygon
              id="chevronLeftIcon"
              points="14.7890625 7.7890625 10.578125 12 14.7890625 16.2109375 13.5 17.5 8 12 13.5 6.5"
            ></polygon>
          </defs>
          <g
            id="Style-Guide"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Blaize-Studio---Icons"
              transform="translate(-852.000000, -2930.000000)"
            >
              <g id="General-Icons" transform="translate(56.000000, 753.000000)">
                <g id="row" transform="translate(0.000000, 2133.000000)">
                  <g id="Icon" transform="translate(641.000000, 0.000000)">
                    <g
                      id="general-/-chevron-left-/-Default"
                      transform="translate(147.000000, 38.000000)"
                    >
                      <rect id="Container" x="0" y="0" width="24" height="24"></rect>
                      <mask id="mask-2" fill="white">
                        <use xlinkHref="#chevronLeftIcon"></use>
                      </mask>
                      <use
                        id="chevron-left"
                        fill="currentColor"
                        xlinkHref="#chevronLeftIcon"
                      ></use>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

ChevronLeftIcon.propTypes = {
  className: PropTypes.string,
};

export default ChevronLeftIcon;
